import _classCallCheck from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/vercel/path0/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import randombytes from 'randombytes';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import base64urlLib from 'base64url';
import keccakLib from 'keccak';

var randomId = function randomId() {
  return randombytes(32).toString("hex");
};

var URLWithHashParams = /*#__PURE__*/function (_URL) {
  _inherits(URLWithHashParams, _URL);

  function URLWithHashParams() {
    var _this;

    _classCallCheck(this, URLWithHashParams);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(URLWithHashParams).apply(this, arguments));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hashParams", new URLSearchParams());

    return _this;
  }

  _createClass(URLWithHashParams, [{
    key: "toString",
    value: function toString() {
      this.hash = this.hashParams.toString();
      return _get(_getPrototypeOf(URLWithHashParams.prototype), "toString", this).call(this);
    }
  }]);

  return URLWithHashParams;
}(_wrapNativeSuper(URL));

var base64url = base64urlLib;

function safebtoa(str) {
  return base64url.encode(str);
}

function safeatob(str) {
  // Going backwards: from bytestream, to percent-encoding, to original string.
  return base64url.decode(str);
}

var keccak = keccakLib;

function base64toJSON(b64str) {
  return JSON.parse(base64url.decode(b64str));
}

function jsonToBase64(json) {
  return base64url.encode(JSON.stringify(json));
}

function keccak256(str) {
  var input = str;

  if (typeof str === "string" && str.slice(0, 2) === "0x" && str.length === 66) {
    input = Buffer.from(str.slice(2), "hex");
  }

  var data = "0x".concat(keccak("keccak256").update(input).digest("hex").padStart(64, "0"));
  return data;
}

export { URLWithHashParams, base64toJSON, base64url, jsonToBase64, keccak, keccak256, randomId, safeatob, safebtoa };